// ProfileView.tsx
import React from 'react';
import { ProfileAvatar } from '../profile-avatar/profile-avatar';

export interface ProfileViewProps {
	name: string;
	imageUrl?: string | null;
	sizeProfileAvatar?: string;
	mainComponent: React.ReactNode;
	actionComponent?: React.ReactNode;
}

export const ProfileView = React.forwardRef<HTMLDivElement, ProfileViewProps>(
	({ name, imageUrl, mainComponent, actionComponent, sizeProfileAvatar }, ref) => (
		<div
			ref={ref}
			data-aid="profile-view"
			className="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-2"
		>
			<ProfileAvatar name={name} profilePictureUrl={imageUrl ?? undefined} size={sizeProfileAvatar} />
			<div className="flex-1 min-w-0 text-center sm:text-left">
				<div className="flex items-center space-x-2">
					{/* Main Component */}
					<div className="text-lg font-medium text-gray-900 truncate">{mainComponent}</div>
					{/* Action Component (on the same row as Main Component) */}
					{actionComponent && <div data-aid="profile-view-action">{actionComponent}</div>}
				</div>
			</div>
		</div>
	)
);

ProfileView.displayName = 'ProfileView';
